import { render } from "./Loader.vue?vue&type=template&id=811ff174"
const script = {}

import exportComponent from "/home/mahdi/tmp/management/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__